export class AuthUserRequest {
    user:string;
    password : string;
    Ip:string;
    IdAplicacion:number;

    constructor() {
    this.user = "CUMPLIMIENTOAPIPRINTTEMPLATES";
    this.password = "bfgC0AwgTKG9T/OTc0Hxe+s6zj7ZLK0kyuQkIUQ6yq2B8H3JAs3f41l0pVQJ/7iU/I+pyfbuvjw8HHLWtcS47x0lrlONMDj/AjG3yyWSkrCAX5qq7ATf3faEYB94YRySU5zJUErusrtlNf8l43Et+AzFFPyTgkLg/0Do0cYjYztNp8T2sQ1I2jOBQ+ExikRhvBubOfA6LyIPJD90RWRu8MDEof8EXcL4PrEFv6Y3ri4pZokRP9+AktBxYDdinRV2K3UUUFTHcikuX7oYRUOCAfyPdMXMi3IbggJsATpn59AjIoy3ki6WVX8bN3X2htkCpYp51z6hnhLQBgY5KRoscg==";
    this.Ip ="192.168.98.180";
    this.IdAplicacion = 38;
    }
}

export interface AuthUserResponse {
    status: boolean;
    statusCode: number;
    mensaje: string;
    result: TokenResult;
}

export interface TokenResult {
    token:string;
    vigencia: string;
}
